const isInscriptionId = (id: string): boolean => {
	const parts = id.split('i')

	if (parts.length != 2) {
		return false
	}

	if (parts[0].length != 64) {
		return false
	}

	const value = parseInt(parts[1])

	if (isNaN(value)) {
		return false
	}

	return true
}

export default isInscriptionId
